// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9653f409","952":"5c7c1e09"}[chunkId] + ".chunk.js";
};